module.exports = __webpack_public_path__ + "img/ImRad.ba908f6e.jpg";